import { Box, Typography } from "@mui/material";
import React from "react";

const WiktionaryAttribution = () => {
    return (
        <Box sx={{ mt: 'auto', pt: 2, borderTop: '1px solid #e0e0e0' }}>
            <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem', lineHeight: 1.4 }}>
                Definitions adapted from{' '}
                <Box
                    component="a"
                    href="https://en.wiktionary.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{
                        color: 'primary.main',
                        textDecoration: 'none',
                        '&:hover': {
                            textDecoration: 'underline'
                        }
                    }}
                >
                    Wiktionary
                </Box>
                . CC-BY-SA 3.0.
            </Typography>
        </Box>
    );
};

export default WiktionaryAttribution;

